import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const footerAISchema: AISchemaField[] = [
  { name: 'brand', type: 'string', required: true, max: 30 },
  { name: 'tagline', type: 'string', required: false, max: 120 },
  {
    name: 'columns',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'title', type: 'string', required: true, max: 30 },
      {
        name: 'links',
        type: 'array<object>',
        required: true,
        fields: [
          { name: 'label', type: 'string', required: true, max: 30 },
          { name: 'href', type: 'url', required: false },
        ],
      },
    ],
  },
  { name: 'copyright', type: 'string', required: false, max: 120 },
];

export const footerUISchema: UISchemaField[] = [
  { name: 'brand', type: 'text', label: 'Brand', required: true, max: 30 },
  { name: 'tagline', type: 'textarea', label: 'Tagline', max: 120 },
  { name: 'columns', type: 'footer_columns', label: 'Footer columns', required: true },
  { name: 'copyright', type: 'text', label: 'Copyright', max: 120 },
];

export const footerZodSchema = z.object({
  brand: z.string().min(1).max(30),
  tagline: z.string().max(120).optional().nullable(),
  columns: z
    .array(
      z.object({
        title: z.string().max(30),
        links: z
          .array(
            z.object({
              label: z.string().max(30),
              href: z.string().optional().nullable(),
            }),
          )
          .min(1),
      }),
    )
    .min(1)
    .max(5),
  copyright: z.string().max(120).optional().nullable(),
});

export type FooterContent = z.infer<typeof footerZodSchema>;

export const footerSample: FooterContent = {
  brand: 'Atlas',
  tagline: 'Built for the work that matters.',
  columns: [
    {
      title: 'Shop',
      links: [
        { label: 'Atlas Pro', href: '#' },
        { label: 'Atlas Air', href: '#' },
        { label: 'Atlas Mini', href: '#' },
        { label: 'Accessories', href: '#' },
      ],
    },
    {
      title: 'Support',
      links: [
        { label: 'Help center', href: '#' },
        { label: 'Setup guides', href: '#' },
        { label: 'Repair', href: '#' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About', href: '#' },
        { label: 'Careers', href: '#' },
        { label: 'Press', href: '#' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy', href: '#' },
        { label: 'Terms', href: '#' },
        { label: 'Cookies', href: '#' },
      ],
    },
  ],
  copyright: '© 2026 Atlas Computer, Inc.',
};
